<script lang="ts">
  import { goto } from '$app/navigation';
  import type { Leaderboard } from '$lib/api/types';
  import { formatDate } from '$lib/util';
  import TableMessage from '../TableMessage.svelte';

  interface Props {
    leaderboards: Leaderboard[];
  }

  let { leaderboards }: Props = $props();
</script>

<div class="list-group">
  {#each leaderboards as lb (lb.classId)}
    <a href="/classes/{lb.classId}" class="list-group-item list-group-item-action">
      <h4 class="list-group-title">{lb.class.name}</h4>
      <div class="list-group-subtitle">{formatDate(lb.class.startDate)} &mdash; {formatDate(lb.class.endDate)}</div>
    </a>
  {/each}
</div>

{#if leaderboards.length === 0}
  <TableMessage message="No classes" />
{/if}
